import axios from 'axios';

export type CreateDealParams = {
	contactId: string;
	dealName: string;
	address?: string;
	city?: string;
	state?: string;
	zip?: string;
	getToken: () => Promise<string>;
};

export const createDeal = async (params: CreateDealParams): Promise<[any, string | null]> => {
	const { contactId, dealName, address, city, state, zip, getToken } = params;

	try {
		const token = await getToken();
		const response = await axios.post(
			`${import.meta.env.VITE_API_URL}/deals`,
			{ contactId, dealName, address, city, state, zip },
			{
				headers: {
					Authorization: `Bearer ${token}`
				}
			}
		);

		if (response.status !== 200) {
			return [null, response.data];
		}

		return [response.data, null];
	} catch (error) {
		const errorMessage = error instanceof Error ? error.message : 'Error creating deal';
		return [null, errorMessage];
	}
};
